// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"b4ad4a35","2336":"ba1a0e84","4965":"d4127441","6911":"116969a4","9449":"323db9fb","9604":"d15292ad"}[chunkId] + ".chunk.css";
};